import { filelist } from "./filelists/filelist20251216"

export default {
    id: 35,
    name: "20251216InformationWriting",
    type: "InformationWrting",
    title: "Informationsschreiben und Besoldungsentscheide des Kantonalen Kirchenvorstandes per 1. Januar 2026",
    subtitle: "(Teuerungsausgleich / Lohntabellen / Meldung Steuerfuss / Meldung Katholikenzahl / Formular Wiedereintritt)",
    value: `
Der Kantonale Kirchenvorstand beschloss:<br>
Die “Lohnklassen und Lohnstufen” gemäss Anhang 2 der Personal- und Besoldungsverordnung werden per 1. Januar 2026 für das Jahr 2026 auf dem Indexstand von 109.3 Punkten (auf der Basis Dezember 2005 = 100 Punkte) belassen.<br>
Die Kirchgemeinden haben den beschlossenen Steuerfuss für das Jahr 2026 mittels des Formulars bis allerspätestens am 22. Dezember 2025 zu melden.<br>
Die Katholikenzahlen per 1. Januar 2026 etc. sind mittels des Formulars bis am 31. Januar 2026 von den Kirchgemeinden zu melden.<br>
Es steht ein Formular für einen einfachen, unbürokratischen Wiedereintritt in die Kirchgemeinde zur Verfügung. Die Kirchgemeinden werden ersucht, dieses Formular auf ihren Homepages aufzuschalten.<br>
    `,
    target: "InfoSite",
    Post: true,
    date: 20251216,
    files: {
        filesTitle: "Brief und Formulare:",
        filesList: filelist
    }
}
